<div class="idv" (click)="openModal()">
  @if (previewUrl && !previewLoading) {
    <div class="idv__image-wrap" itfgZoomImage>
      <img [src]="previewUrl" [alt]="label" />
    </div>
  } @else {
    <div class="idv__image-wrap">
      <div class="idv__overlay"
           [class.idv__overlay--muted]="!previewLoading"
           [class.idv__overlay--error]="previewError">
        @if (previewLoading || loading) { 
          <mat-spinner diameter="28" />
        }
        @else if (previewError) {
           <mat-icon>broken_image</mat-icon>
          }
        @else {
           <mat-icon>image_not_supported</mat-icon>
           }
      </div>
    </div>
  }
</div>

<ng-template #viewerModalTpl>
  <div class="idv-modal">
    <div class="idv-modal__header">
      <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="idv-modal__body" [class.idv-modal__body--same]="isSamePinAndSelected">

      <div class="idv-modal__image-panel"
           [class.idv-modal__image-panel--pin-slot-open]="!!pinnedDoc">
        @if (pinnedDoc) {
          <div class="idv-modal__panel-label">
            <mat-icon class="idv-modal__panel-label-icon">compare</mat-icon>
            <span class="idv-modal__panel-label-text">{{ pinnedDoc.name || ('doc #' + pinnedDoc.id) }}</span>
            @if (pinnedDoc.type?.name) { 
              <span class="idv-modal__panel-type-chip">{{ pinnedDoc.type.name }}</span>
            }
          </div>
          <!-- pinned panel -->
          @if (pinnedImageUrl && !loadingPinned) {
            <div class="idv-modal__image-wrap" itfgZoomImage [url]="pinnedImageUrl">
              <img [src]="pinnedImageUrl" [alt]="pinnedDoc.name" />
            </div>
          } @else {
            <div class="idv-modal__image-wrap idv-modal__image-wrap--empty">
              @if (loadingPinned) {
                 <mat-spinner diameter="40" />
              }
              @else if (errorPinned) { 
                <mat-icon>broken_image</mat-icon>
              }
            </div>
          }
        }
      </div>

      <div class="idv-modal__image-panel">
          <div class="idv-modal__panel-label">
            <mat-icon class="idv-modal__panel-label-icon">visibility</mat-icon>
            <span class="idv-modal__panel-label-text">
              {{ currentDoc?.name || ('doc #' + currentDoc?.id) }}
            </span>
            @if (currentDoc?.type?.name) {
               <span class="idv-modal__panel-type-chip">{{ currentDoc!.type.name }}</span>
              }
          </div>
        @if (modalUrl && !modalLoading) {
          <!-- selected panel -->
          <div class="idv-modal__image-wrap" itfgZoomImage [url]="modalUrl">
            <img [src]="modalUrl" [alt]="documentType" />
          </div>
        } @else {
          <div class="idv-modal__image-wrap idv-modal__image-wrap--empty">
            @if (modalLoading)    { 
              <mat-spinner diameter="40" />
            }
            @else if (modalError) {
              <mat-icon>broken_image</mat-icon> 
            }
            @else {
              <mat-icon>image_not_supported</mat-icon>
            }
          </div>
        }
      </div>

      <div class="idv-modal__list-panel">
        <div class="idv-modal__list-head">
          <span class="s26-label">{{'global.documents' | translate}}</span>
        </div>

        @if (loadingList) {
          @for (_ of [1,2,3]; track $index) {
            <div class="idv-modal__list-item idv-modal__list-item--skeleton">
              <div class="s26-skeleton s26-skeleton--icon"></div>
              <div class="s26-skeleton s26-skeleton--text"></div>
            </div>
          }
        } @else if (!docList.length) {
          <div class="s26-empty">
            <span>{{'verification.id.noDocumentsMessage' | translate}}</span>
          </div>
        }

        @for (doc of docList; track doc.id) {
          <div class="idv-modal__list-item"
               [class.idv-modal__list-item--selected]="currentDoc?.id === doc.id"
               [class.idv-modal__list-item--pinned]="pinnedDoc?.id === doc.id"
               (click)="selectDoc(doc)">
            <div class="idv-modal__item-meta">
              <div>
                @if (doc.type?.name) {
                  <span class="idv-modal__item-type">{{ doc.type.name }}</span>
                }
                @if (doc.createdAt) {
                  <span class="idv-modal__item-date">{{ doc.createdAt | date:'dd.MM.yy' }}</span>
                }
              </div>
            </div>
            <button class="idv-modal__pin-btn"
                    [class.idv-modal__pin-btn--active]="pinnedDoc?.id === doc.id"
                    [matTooltip]="pinnedDoc?.id === doc.id ? 'Unpin' : 'Pin for comparison'"
                    (click)="pinDoc(doc, $event)">
              <mat-icon>compare</mat-icon>
            </button>
          </div>
        }
      </div>

    </div>
  </div>
</ng-template>